import {useQueries} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import resalesService from "../../../services/resales-service";

const UseFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryFn: () => projectService.listLicensing().then(({data}) => data),
                queryKey: ["licensing"],
            },
            {
                queryFn: () => projectService.options().then(({data}) => data),
                queryKey: ["projects"]
            },
            {
                queryFn: () => resalesService.options().then(({data}) => data),
                queryKey: ["resales"]
            }
        ]
    });

    return {
        licensesFetch: queries[0].data,
        projects: queries[1].data,
        resales: queries[2].data,
    }
};

export default UseFetchData;